import * as React from 'react'
import { Icon, Badge } from '../'
import classNames from 'classnames'
import './button.scss'

interface ButtonProps {
  href?: string
  class?: string
  target?: string
  rel?: string
  size?: ButtonSize
  display?: ButtonDisplay
  style?: ButtonStyle
  unstyled?: boolean
  disabled?: boolean
  iconLeft?: string
  iconRight?: string
  badge?: number | boolean
  compactBadge?: boolean
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  // If provided a "to" prop, this element will create a Link component rather than an anchor
  to?: string
  gtmId?: string
  children?: React.ReactNode
}

export type ButtonSize = 'small' | 'large'
export type ButtonDisplay = 'block' | 'wide' | 'flush' | 'narrow' | 'slim' | 'icon-only'
export type ButtonStyle = 'outline' | 'outline-grey' | 'link' | 'unstyled' | 'grey' | 'pill' | 'pill-outline' | 'text-small' | 'text-medium'

export class Button extends React.Component<ButtonProps> {
  render(): React.ReactNode {
    const buttonClasses: string = classNames(
      { [this.props.class]: this.props.class },
      { ['button']: !this.props.unstyled },
      { [`button--${this.props.size}`]: this.props.size },
      { [`button--${this.props.display}`]: this.props.display },
      { [`button--${this.props.style}`]: this.props.style },
      { ['button--disabled']: this.props.disabled }
    )

    return (
      <a
        data-gtm-id={this.props.gtmId}
        href={this.props.href}
        className={buttonClasses}
        target={this.props.target}
        rel={this.props.rel}
        onClick={this.props.onClick}
      >
        {this.props.iconLeft && <Icon className='button__icon button__icon--left' icon={this.props.iconLeft} />}
        {this.props.children}
        {this.props.iconRight && <Icon className='button__icon button__icon--right' icon={this.props.iconRight} />}
        {this.props.badge && <Badge className='button__badge' value={this.props.badge} compact={this.props.compactBadge} />}
      </a>
    )
  }
}
